<template>
  <div class="site-page site-page--hub nav-content-inset">
    <div class="site-page__inner">
      <AccountWalletNav />
      <h1 class="site-page__title">提现申请</h1>
      <p class="hint">
        须先完成<strong>实名认证</strong>，再填写银行卡信息提交；审核通过后由财务批量打款。
      </p>

      <el-alert
        v-if="!loadingProfile && !isVerified"
        type="warning"
        :closable="false"
        show-icon
        title="请先完成实名认证"
        class="verify-alert"
      >
        <template #default>
          <p>提现需上传身份证并通过审核。认证通过后户名将自动填入。</p>
          <el-button type="primary" size="small" @click="$router.push('/real-name-verification')">
            去实名认证
          </el-button>
        </template>
      </el-alert>

      <el-steps :active="stepActive" align-center class="steps-bar" finish-status="success">
        <el-step title="实名认证" description="上传身份证" />
        <el-step title="填写银行卡" description="开户行 / 卡号 / 户名" />
        <el-step title="等待审核打款" description="可在下方查看进度" />
      </el-steps>

      <el-card shadow="never" class="apply-card">
        <el-form label-width="100px">
          <el-form-item label="提现金额（元）" required>
            <el-input-number v-model="amountYuan" :min="1" :max="100000" :precision="2" :disabled="!isVerified" />
          </el-form-item>
          <el-form-item label="开户银行" required>
            <el-input v-model="form.bankName" placeholder="如：中国工商银行" :disabled="!isVerified" />
          </el-form-item>
          <el-form-item label="银行卡号" required>
            <el-input v-model="form.bankAccount" placeholder="收款银行卡号" :disabled="!isVerified" />
          </el-form-item>
          <el-form-item label="户名" required>
            <el-input v-model="form.accountName" placeholder="须与实名认证姓名一致" :disabled="!isVerified" />
            <p v-if="verifiedName && form.accountName === verifiedName" class="field-tip">已与实名认证姓名一致</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submitting" :disabled="!isVerified" @click="submit">
              提交申请
            </el-button>
            <el-button @click="$router.push('/my')">返回我的</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <h3>申请记录</h3>
      <el-table :data="items" v-loading="loading" border>
        <el-table-column label="金额（元）" width="110">
          <template #default="s">{{ (s.row.amountCents / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="bankName" label="银行" width="120" />
        <el-table-column prop="status" label="状态" width="130">
          <template #default="s">{{ withdrawLabel(s.row.status) }}</template>
        </el-table-column>
        <el-table-column prop="adminReply" label="备注" min-width="140" />
        <el-table-column label="时间" width="170">
          <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import AccountWalletNav from '@/components/AccountWalletNav.vue'
import {
  fetchWithdrawApplyList,
  submitWithdrawApply,
  fetchUserVerificationBrief,
  fetchIdCardProfile,
  WITHDRAW_STATUS_LABELS
} from '@/utils/userHub'

export default {
  name: 'WithdrawApplyView',
  components: { AccountWalletNav },
  data() {
    return {
      amountYuan: 10,
      form: { bankName: '', bankAccount: '', accountName: '' },
      submitting: false,
      loading: false,
      loadingProfile: true,
      isVerified: false,
      verifiedName: '',
      items: []
    }
  },
  computed: {
    stepActive() {
      if (!this.isVerified) return 0
      return 1
    }
  },
  created() {
    this.loadProfile()
    this.loadList()
  },
  methods: {
    withdrawLabel(s) {
      return WITHDRAW_STATUS_LABELS[s] || s
    },
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(Number(ts) * 1000).toLocaleString()
    },
    async loadProfile() {
      this.loadingProfile = true
      try {
        const brief = await fetchUserVerificationBrief()
        this.isVerified = brief.isVerified
        const idcard = await fetchIdCardProfile()
        if (idcard?.realName) {
          this.verifiedName = idcard.realName
          if (!this.form.accountName) {
            this.form.accountName = idcard.realName
          }
        }
      } catch (e) {
        console.warn('load verification profile failed', e)
      } finally {
        this.loadingProfile = false
      }
    },
    async loadList() {
      this.loading = true
      try {
        const data = await fetchWithdrawApplyList()
        this.items = data.items || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async submit() {
      if (!this.isVerified) {
        this.$message.warning('请先完成实名认证')
        this.$router.push('/real-name-verification')
        return
      }
      this.submitting = true
      try {
        await submitWithdrawApply({
          amountCents: Math.round(this.amountYuan * 100),
          ...this.form
        })
        this.$message.success('提现申请已提交')
        this.loadList()
      } catch (e) {
        this.$message.error(e.message || '提交失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
.apply-card { margin-bottom: 24px; }
.verify-alert { margin-bottom: 16px; }
.verify-alert p { margin: 0 0 10px; }
.steps-bar { margin-bottom: 20px; }
.field-tip { margin: 6px 0 0; font-size: 12px; color: #67c23a; }
</style>
